<template>
    <div>
        <!-- <a-spin :spinning="spinning" :tip="$t('spin.text')"> -->
            <template v-if="!dataType">
                <template v-if="current == 0">
                    <div class="box" :class="$vuetify.theme.dark ? 'box-d': ''">
                        <div class="list">
                            <v-row class="px-2 ma-0" v-if="showIosCode">
                                <v-col cols="12" md="12" style="padding:0;">
                                    <div>{{$t('account.dynamic.codeTitle')}} </div>
                                </v-col>
                                <v-col cols="12" md="12" >
                                    <div style="margin-bottom: 20px">{{$t('account.dynamic.newVersion')}}</div>
                                </v-col>
                                <v-col cols="12" md="12" style="padding:0;">
                                    <div class="download-code">
                                        <div class="code-box" :class="$vuetify.theme.dark ? 'code-box-d': ''" ref="iosCode"></div>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row class="px-2 ma-0" v-else>
                                <v-col cols="12" md="12" >
                                    <div class="text">{{$t('account.dynamic.comingSoon')}}</div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="app-d" :class="$vuetify.theme.dark ? 'app-d-dark': ''">{{$t('account.dynamic.app')}}<a href="javascript:" @click="addFun" style="color:#5066e0">{{$t('account.dynamic.code')}}</a></div>

                    <v-row no-gutters>
                        <v-col cols="12" md="12" class="btn-group ">
                            <v-btn small outlined @click="close">{{$t('btn.closeBtn')}}</v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-else>
                    <div class="two-box" :class="$vuetify.theme.dark ? 'two-box-d': ''">
                        <v-row class="px-2 ma-0">
                            <v-col cols="12" md="12" style="padding:0;">
                                <div>{{$t('account.dynamic.appCode')}}</div>
                            </v-col>
                            <v-col cols="12" md="12" style="padding:0;">
                                <div>{{$t('account.dynamic.activateCode')}}</div>
                            </v-col>
                            <v-col cols="12" md="12" style="padding:0;">
                                <div class="code" :class="$vuetify.theme.dark ? 'code-d': ''" v-if="codeUrl" ref="qrCodeUrl"></div>
                            </v-col>
                            <v-col cols="12" md="12" style="padding:0;">
                                <div>{{$t('account.dynamic.app2')}}<a href="javascript:" @click="downFunc" style="color:#5066e0">{{$t('account.dynamic.downloadCode')}}</a></div>
                            </v-col>
                        </v-row>
                    </div>
                    <v-row no-gutters class="btn-group two-btn-group">
                        <v-col cols="12" sm="12">
                            <v-btn small color="primary" @click="subFun">{{$t('account.dynamic.subBtn')}}</v-btn>
                            <v-btn small outlined class="close_btn" @click="close">{{$t('btn.close')}}</v-btn>
                        </v-col>
                    </v-row>
                </template>
            </template>
            <template v-else>
                <v-col class="title" :class="$vuetify.theme.dark ? '': 'title-l'" cols="12" >
                    {{$t('account.FIDO.safetyVerification')}}
                </v-col>
                <v-form
                    ref="fidoForm"
                    v-model="valid"
                    class="form-box formStyle">
                    <v-text-field
                        outlined
                        disabled
                        dense
                        :value="dataList.mobile"
                        :label="$t('account.pghoess')"
                        hide-details="auto"
                        class="mb-6"
                    ></v-text-field>
                    <v-row no-gutters>
                        <v-col cols="8" md="8" lg="8" xl="8" sm="12">
                            <v-text-field
                                v-model="form.code"
                                outlined
                                required
                                dense
                                :rules="dynamicFormRule.code"
                                :label="$t('account.code')"
                                :placeholder="$t('account.codePlaceholder')"
                                @keyup="(v) =>(form.code = v.target.value.replace(/[^\d]/g,''))"
                                hide-details="auto"
                                class="mb-6 code-btn"
                            ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="3" md="3" lg="3" xl="3" sm="12" class="code-box  ml-1 d-flex justify-end align-baseline" :class="codeText == $t('account.getCode')?'cursor-pointer':'text'" @click="getCode">
                            <v-btn small outlined v-if="codeText == $t('account.getCode')" color="primary" min-height="40" style="width:118%">{{codeText}}</v-btn>
                            <v-btn small outlined v-else style="width:118%" disabled min-height="40">{{codeText+'s'}}</v-btn>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12"  sm="12" class="mb-4">
                            <v-btn color="primary" @click="onSubmit" small>{{$t('btn.submit')}}</v-btn>
                            <v-btn small class="close_btn" outlined @click="close">{{$t('btn.close')}}</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        <!-- </a-spin> -->
    </div>
</template>

<script>
import { getUAFTokenActiveQrcode, smsReset, getPushResult, resetUAFToken, activationUAFToken, codeDownload } from "@/api/index";
import QRCode from 'qrcodejs2'
import store from '@/store'

export default {
    data() {
        return {
            valid: false,
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            form: {},
            dynamicFormRule:
                {
                    code: [
                        v => !!v || this.$t('account.codePlaceholder'),
                        v => (/^[0-9]{6}$/.test(v)) || this.$t('account.code6')
                    ],
                },
            codeText: this.$t('account.getCode'),
            current: 0,
            // codeTt: '离线二维码',
            codeUrl: false,
            spinning: false,
            showIosCode: true,
            // showAndroidCode: true
            // optText: '推送'
        };
    },
    props: {
        dataType: Boolean,
        dataList: Object
    },
    mounted() {
        if (this.dataType) {
            this.$root.eventHub.$on('handleCancel5', ()=> {
                this.$refs.fidoForm.resetValidation();
                this.$root.eventHub.$off("handleCancel5")
            })
        } else {
            this.addFun()
            //this.getQRCode()
        }
    },
    methods: {
        onSubmit() {
            if(this.$refs.fidoForm.validate()){
                this.spinning = true
                resetUAFToken({
                    code: this.form.code,
                    // phonesn: this.form.phone
                }).then(res=> {
                    if (res.code == this.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        this.spinning = false
                        this.$emit("onSubmit")
                        // let num = 60
                        // this.pushKey = true
                        // let timer = setInterval(()=>{
                        //     getPushResult({
                        //         reqId: res.data,
                        //         type: 'u'
                        //     }).then(res2=> {
                        //         if (res2.code == 200) {
                        //             this.$message.success(res.message)
                        //             clearInterval(timer)
                        //             this.spinning = false
                        //             this.$emit("onSubmit")
                        //         } else if (res2.code == 0) {
                        //             this.spinning = false
                        //             clearInterval(timer)
                        //         }
                        //     })
                        //     num--
                        //     if(num <= 0) {
                        //         this.spinning = false
                        //         clearInterval(timer)
                        //     }
                        // }, 1000)
                    } else {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                        this.spinning = false
                    }
                })
            }
        },
        close() {
            this.$emit("close")
        },
        getCode() {
            // let list = ['phone']
            // let num = 0
            // this.$refs.fidoForm.validateField(list, valid => {
            //     if (!valid) {
            //         num ++
            //     }
            // })
            // if(this.codeText == "获取验证码" && num == list.length) {
            if(this.codeText == this.$t('account.getCode')) {
                this.spinning = true
                let params = {
                    // phonesn: this.form.phone,
                    smsType: this.$getSmsModel('Fido')
                }
                smsReset(params).then(res=> {
                    this.spinning = false
                    if (res.code == this.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        this.codeText = 60
                        let timer = setInterval(()=>{
                            this.codeText--
                            if(this.codeText <= 0) {
                                clearInterval(timer)
                                this.codeText = this.$t('account.getCode')
                            }
                        },1000)
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                }).catch(err=> {
                    this.spinning = false
                })
            }
        },
        downFunc(){

            this.getQRCode()
            this.codeUrl = false
            this.current = 0;
            this.$refs.qrCodeUrl.innerHTML = ""
        },
        addFun() {
            this.current = 1
            this.codeUrl = true
            // 设置二维码
            getUAFTokenActiveQrcode().then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    let qrcodeCreater = new QRCode(this.$refs.qrCodeUrl, {
                        text: res.data.activecode,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        width: 200,
                        height: 200,
                        typeNumber: 100,
                        correctLevel: QRCode.CorrectLevel.L
                    })
                    qrcodeCreater._el.title = ""
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },
        subFun() {
            activationUAFToken().then(res=> {
                if(res.code == this.$GLOBA.StatusOK) {
                    this.$emit("subFun")
                }
            })
        },
        getQRCode() {
            codeDownload().then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    if (res.data.android) {
                        this.showIosCode = true
                        let qrcodeCreaterIos = new QRCode(this.$refs.iosCode, {
                            text: res.data.android,
                            colorDark: '#000000',
                            colorLight: '#ffffff',
                            width: 200,
                            height: 200,
                            typeNumber: 4,
                            correctLevel: QRCode.CorrectLevel.L
                        })
                        qrcodeCreaterIos._el.title = ""

                        // this.showAndroidCode = true
                        // let qrcodeCreater = new QRCode(this.$refs.androidCode, {
                        //     text: res.data.android,
                        //     colorDark: '#000000',
                        //     colorLight: '#ffffff',
                        //     width: 200,
                        //     height: 200,
                        //     typeNumber: 4,
                        //     correctLevel: QRCode.CorrectLevel.L
                        // })
                        // qrcodeCreater._el.title = ""
                    } else {
                        this.showIosCode = false
                        // this.showAndroidCode = false
                    }
                }
            })
        }
        // goCode() {
        //     this.codeUrl = false
        //     this.codeTt = this.codeTt == "离线二维码" ? "在线二维码" : "离线二维码"
        //     setTimeout(()=>{
        //         this.addFun()
        //     },0)
        // }
    },
};
</script>

<style scoped lang="scss">
::v-deep .ant-input-group-addon {
    min-width: 93px;
    background: none;
}
.get-code {
    cursor: pointer;
    color: #5066e0;
}
.title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin: 10px 0 20px 0;
}
.title-l {
    color: #333;
}
.code-btn ::v-deep .ant-input {
    border-right: 0;
}
.push-text {
    color: #337DF7;
}
.tip {
    margin-left: 40%;
    width: 100%;
}
.ant-steps {
    width: 60%;
    margin: 20px auto 100px;
}
.box {
    display: flex;
    font-size: 14px;
    color: #333;
    padding-top: 16px;
    .list {
        flex: 1;
        text-align: center;
        .d-text {
            margin: 5px 0 50px;
        }
        .download-code {
            display: flex;
            justify-content: center;
            margin-bottom: 20px;
            .code-box {
                background: #FFFFFF;
                padding: 21px;
                box-shadow: 0px 0px 14px 1px rgba(0, 0, 0, 0.16);
            }
            .code-box-d {
                background: #3B355A;
            }
        }
        .text {
            font-weight: bold;
            font-size: 18px;
        }
    }
}
.box-d {
    color: rgba(231, 227, 252, 0.68) !important;
}
.btn-group {
    text-align: center;
    margin-bottom: 20px;
}
.two-box {
    // width: 460px;
    background: #FFFFFF;
    // border: 1px solid #d9d9d9;
    margin: 0 auto;
    padding: 16px 0 20px;
    font-size: 14px;
    text-align: center;
    color: #333;
    ::v-deep .code {
        margin: 30px auto 20px;
        justify-content: center;
        display: flex;
        width: 250px;
        max-width: 250px;
        height: 250px;
        background: #FFFFFF;
        padding: 21px;
        box-shadow: 0px 0px 14px 1px rgba(0, 0, 0, 0.16);
         img{
            width: 100%;
             max-width: 200px;
             min-width: 200px;
        }
    }
    .code-d {
        // background: #3B355A;
    }
}
.two-box-d {
    background: none;
    color: rgba(231, 227, 252, 0.68) !important;
}
.two-btn-group {
    margin-top: 20px;
}
// .code-text {
//     color: #1890ff;
//     cursor: pointer;
// }
::v-deep .ant-btn-round{
    margin-right: 32px;
    width: 96px;
    height: 38px;
    border-radius: 6px;
    background: #5066e0;
    font-size: 18px;
}
::v-deep .ant-modal-title{
    line-height: 29px;
    margin-left: 16px;
    font-size: 18px;
}
.app-d {
    text-align: center;
    // font-size: 16px;
    color: #333;
    margin-bottom: 20px;
}
.app-d-dark {
    color: rgba(231, 227, 252, 0.68) !important;
}
.formStyle{
    width: 70%;
    margin-left: 15%;
}
::v-deep .row {
    align-items: start !important;
}
.close_btn{
    margin-left: 10px;
}
.code-box ::v-deep {
  .v-btn.theme--dark {
    border-color: rgba(231, 227, 252, 0.28) !important;
    .v-btn__content{
      color:rgba(231, 227, 252, 0.67);
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px){
    .close_btn{
        margin-left: 6px;
    }
    ::v-deep {
        .v-text-field.v-text-field--enclosed .v-text-field__details{
            padding: 0;
        }
    }
    .formStyle{
        width: 106%;
        margin-left: -3%;
    }
}
</style>
